/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type RoleDropdown_roles$ref: FragmentReference;
declare export opaque type RoleDropdown_roles$fragmentType: RoleDropdown_roles$ref;
export type RoleDropdown_roles = $ReadOnlyArray<{|
  +node: ?{|
    +name: ?string,
    +id: string,
  |},
  +$refType: RoleDropdown_roles$ref,
|}>;
export type RoleDropdown_roles$data = RoleDropdown_roles;
export type RoleDropdown_roles$key = $ReadOnlyArray<{
  +$data?: RoleDropdown_roles$data,
  +$fragmentRefs: RoleDropdown_roles$ref,
  ...
}>;
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "RoleDropdown_roles",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Role",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RoleTypeEdge"
};
// prettier-ignore
(node/*: any*/).hash = '49d6e05bfe0a411559b89059c240ec10';

module.exports = node;
